<template>
<div class="box-labourParticulars">
    <div class="nav">
        <router-link to="Appendix"><img src="../../assets/up.png" alt="" class="upClass"></router-link>
        员工报班优惠制度
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">员工优惠报名的标准</h4>
                    <p class="labourParticulars-title-content-active">1. 新东方员工亲友：每自然年可享受 2 次 8 折报班优惠，具体优惠最高限额如下：</p>
                    <span class="spanClass labourParticulars-title-content-active">泡泡少儿部 300 元</span>
                    <span class="spanClass labourParticulars-title-content-active">国内考试部 800 元</span>
                    <span class="spanClass labourParticulars-title-content-active">优能中学部 800 元</span>
                    <span class="spanClass labourParticulars-title-content-active">优能一对一部 800 元</span>
                    <span class="spanClass labourParticulars-title-content-active">国外考试部课程原价 1 万元以内优惠最高上限 300 元，1 万元以上优惠最高上限 800 元。</span>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">员工优惠报名的标准</h4>
                    <p class="labourParticulars-title-content-active">2. 新东方员工本人或者员工子女报名，每自然年可享受多次 5 折报班优惠。</p>
                    <span class="spanClass labourParticulars-title-content-active">其中当年内首次单班报名学费在 5000 元以下可享受费用全免，首次单班报名学费在 5000 元以上则可减免 5000 元（泡泡少儿部多元智能班课程除外，其全年班&半年班的第一个班号学费的五折优惠上限为 2500元）。从第二次开始以后报名均可享受最高优惠 2000 元。</span>
                    <p class="labourParticulars-title-content-active">注：优能一对一部课程，国内考试部及国外考试部 VIP 课程不享受五折优惠。</p>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">员工优惠报名的标准</h4>
                    <p class="labourParticulars-title-content-active">3. 国际游学部课程优惠政策如下：</p>
                    <span class="spanClass labourParticulars-title-content-active">新东方员工及子女报名非亚洲产品优惠 2000 元；</span>
                    <span class="spanClass labourParticulars-title-content-active">新东方员工及子女报名亚洲产品优惠 1000 元；</span>
                    <span class="spanClass labourParticulars-title-content-active">新东方员工及子女报名国内研学&营地教育项目优惠 600 元，报名成人游学&海外教师培训项目优惠 1500 元。</span>
                    <p class="labourParticulars-title-content-active">注：以上优惠仅限散客线路，渠道和内部团（内部团是指：优能、泡泡、国高等联合设团产品）线路无优惠；以上优惠不与月度，活动，团报三个优惠叠加，可以与推荐优惠叠加。</p>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">员工优惠报名的标准</h4>
                    <p class="labourParticulars-title-content-active">4. 内部员工优惠均不包含教材费。</p>
                    <p class="labourParticulars-title-content-active">5. 套班（例如 A/B 等）视为一个班，仅可使用一次 8 折扣优惠，如使用五折第一次则按照套班总计价格核算。</p>
                    <p class="labourParticulars-title-content-active">6. 因优惠以自然年为核算周期，以员工提交日期为准，来核算是属于哪年的优惠，前一年提交优惠后一年也可使用。</p>
                    <p class="labourParticulars-title-content-active">7. 全校员工优惠标准统一，以上优惠不与其他任何优惠同享，具体报名优惠政策请咨询学校客服工作人员。</p>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
    data() {
        return {
            fingerprintShow: false,
            flowShow: false,
            agreementShow: false
        };
    },
    methods: {
        fn() {

        },
        getOnPage() {
            this.$router.push({
                name: 'Search',
                params: {
                    code: "4"
                }
            })
        },
    },
    mounted() {
        this.fn();
        var mySwiper = new Swiper(".swiper-container", {
            direction: "vertical" // 垂直切换选项
            // loop: true // 循环模式选项
        });
    }
};
</script>

<style>
.swiper-container {
    width: 100%;
    height: 100%;
}

.box-labourParticulars {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
    overflow: hidden;
}

.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.labourParticulars {
    width: 90%;
    height: 83%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
    border-radius: 11px;
    padding-top: 5%;
    position: relative;
}

.labourParticulars .labourParticulars-title {
    text-align: center;
    font-weight: 600;
}

.labourParticulars .labourParticulars-hw {
    margin-bottom: 20px;
}

.labourParticulars p {
    color: #696969;
    font-size: 16px;
    margin: 25px 16px 0;
}

.labourParticulars span {
    display: block;
    line-height: 30px;
    margin-left: 16px;
    margin-right: 16px;
    color: #888787;
    font-size: 14px;
}

.labourParticulars .spanClass {
    text-indent: 30px;
}

.labourParticulars_bottomImg {
    width: 15%;
    display: block;
    left: 0;
    right: 0;
    margin: auto;
    position: absolute;
    bottom: 12px;
}

.QRcode {
    width: 30%;
    display: block;
    margin: 10px auto;
}
.labourParticulars-title-active {
    font-size: 16px
}
.labourParticulars-title-content-active {
    letter-spacing:2px;
    line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Appendix/appendix3.vue